<template>
    <div>
        <!-- List header -->
        <a-row type="flex" :gutter="24">
            <a-col :span="12" class="mb-24">
                <a-dropdown :trigger="['click']" >
                    <a-button class="ant-dropdown-link" @click="e => e.preventDefault()">
                        CATEGORY <a-icon class="ml-5" type="down" />
                    </a-button>
                    <a-menu slot="overlay" @click="handleCategoryChange">
                        <template v-for="c in categories">
                            <a-menu-item :key="c.categoryId"> 
                                {{ c.categoryName }}
                            </a-menu-item>
                        </template>
                    </a-menu>
                </a-dropdown>
            </a-col>

            <a-col :span="12" class="mb-24 text-right">
                
            </a-col>
        </a-row>
        <!-- / List header -->

        <!-- List card -->
        <a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">
            <product-status-list-view :products="productsByCategory(chosenCategory)"/>
        </a-card>
        <!-- / List card -->
    </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import ProductStatusListView from './ProductStatusListView.vue'
export default {
    components : {
        ProductStatusListView,
    },

    computed : {
        ...mapState({
            categories : state => state.products.categoriesFromProductsList
        }),
        ...mapGetters({
            productsByCategory : 'products/productsByCategoryId'
        })
    },
    data () {
        return {
            chosenCategory : null
        }
    },
    methods : {
        openProductAddModal() {

            this.$refs['productAddModal'].showModal();
            
        },

        handleCategoryChange(e) {
            this.chosenCategory = e.key;
        },

        

        async sleep(miliSeconds) {
            return new Promise(r => setTimeout(r, miliSeconds));
        },
    },

    async created () {
        this.$message.loading('Loading data...', 0);
        await this.sleep(2000);
        await this.$store.dispatch('products/getProductsAction', { });
        await this.$store.dispatch('categories/getCategoriesAction', { });
        await this.$store.dispatch('products/getTaxesAction', { });

        //
        //init category
        //
        this.chosenCategory = this.$store.getters['categories/firstCategory']
        this.$message.destroy();
    } 
}
</script>

<style>

</style>